import { Layout } from "../Layout/Layout"
import { H2 } from "../blog/common"
import { Typography } from "antd"
import React from "react"
import { theme } from "../../styles/styles"
import { Section } from "../Section"
import { SubscribeForm } from "../SubscribeForm/SubscribeForm"
import { NextSeo } from "next-seo"
import { webUrl } from "../../config/web"
import { PageHero } from "../IndexHero/PageHero"
import Container from "../Layout/Container"
import { GroupedCourses } from "../GroupedCourses/GroupedCourses"
import Link from "next/link"
import { PrismicCourseOrContentfulProduct } from "../../lib/contentful/PrismicCourseOrContentfulProduct"
import { ProductsColorsItem } from "../../lib/contentful/product/getAllProducts"

const textWhite = theme.colors.dark.textWhite

export const TypeCourseTypeTechnologyPageComponent = ({
  courses,
  productsColors,
  title,
  description,
  long_description,
  url,
  keywords,
  seoDescription
}: Props) => {
  const imageFromContent = undefined

  return (
    <>
      <NextSeo
        title={title}
        description={seoDescription || description}
        canonical={`${webUrl}/${url}`}
        openGraph={{
          url: `${webUrl}/${url}`,
          title,
          description: seoDescription || description,
          ...(imageFromContent && {
            images: [
              {
                url: imageFromContent.url,
                width: 1280,
                height: 964,
                alt: imageFromContent.alt || title
              }
            ]
          })
        }}
      />

      <Layout>
        <section>
          <PageHero
            h1={title}
            text={
              <>
                <Typography.Paragraph style={{ color: textWhite }}>{long_description?.length > 0 ? long_description : description}</Typography.Paragraph>

                {keywords && <Typography.Text style={{ color: textWhite }}>{keywords}</Typography.Text>}
              </>
            }></PageHero>
        </section>

        <Container>
          <GroupedCourses courses={courses} productsColors={productsColors} title={title} />

          <Section>
            <H2 level={2}>Kurzy, které jsme v minulosti pořádali</H2>

            <Typography.Text>
              Máte zájem dozvědět se, které kurzy pro děti jsme v minulosti pořádali? <Link href="/poradali-jsme">Zde je jejich přehled.</Link>.
            </Typography.Text>
          </Section>

          <Section>
            <H2 level={2}>Odběr novinek</H2>
            <SubscribeForm tags={["Krouzky", title]} />
          </Section>
        </Container>
      </Layout>
    </>
  )
}

interface Props {
  courses: PrismicCourseOrContentfulProduct[]
  productsColors?: ProductsColorsItem[]
  title: string
  description: string
  long_description?: string
  seoDescription?: string
  keywords?: string
  url: string
  children?: React.ReactNode
}
